const CANONICAL_ALLOWED_PARAMS = ["id", "slug", "page"];

const DEFAULT_CANONICAL_BASE = "https://www.credencedata.com";

function buildCanonical(fullPath, base = DEFAULT_CANONICAL_BASE) {
  const [pathAndQuery] = fullPath.split("#");
  const [path, query = ""] = pathAndQuery.split("?");
  let url = base + path;
  if (query) {
    const incoming = new URLSearchParams(query);
    const kept = new URLSearchParams();
    CANONICAL_ALLOWED_PARAMS.forEach((p) => {
      if (incoming.has(p)) kept.set(p, incoming.get(p));
    });
    const qs = kept.toString();
    if (qs) url += "?" + qs;
  }
  return url;
}

function buildCanonicalFromRequest(req, base = DEFAULT_CANONICAL_BASE) {
  const kept = new URLSearchParams();
  CANONICAL_ALLOWED_PARAMS.forEach((p) => {
    if (req.query[p] != null) kept.set(p, String(req.query[p]));
  });
  const qs = kept.toString();
  const fullPath = req.path + (qs ? `?${qs}` : "");
  return buildCanonical(fullPath, base);
}

function injectCanonicalLink(html, url) {
  if (/<link\s+rel="canonical"\s+href=".*?"\s*\/?>/i.test(html)) {
    return html.replace(
      /<link\s+rel="canonical"\s+href=".*?"\s*\/?>/i,
      `<link rel="canonical" href="${url}" />`
    );
  }
  return html.replace(
    /<head[^>]*>/i,
    (match) => `${match}\n<link rel="canonical" href="${url}" />`
  );
}

module.exports = {
  CANONICAL_ALLOWED_PARAMS,
  DEFAULT_CANONICAL_BASE,
  buildCanonical,
  buildCanonicalFromRequest,
  injectCanonicalLink,
};
